export const environment = {
  domain: "https://api.nerdof.com/api",
  serverName: "TULA",
}